import Box from '@ilg-totallymoney/ui/components/Box'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'

import ContentList from './ContentList'

const overviewBullets = [
    'A homeowner loan is a loan secured against your property',
    'You can usually borrow larger amounts with a homeowner loan',
    'Homeowner loans also tend to have lower interest rates',
    'Flexible repayment terms from 3 to 30 years',
]

const ContentSecured = () => (
    <Stack space="space30">
        <Heading variant="100">Homeowner loans</Heading>

        <Stack space="space10">
            <Heading variant="40">Overview:</Heading>

            <ContentList>
                {overviewBullets.map((bullet, index) => (
                    <li key={`${bullet}-${index}`}>
                        <Text variant="80">{bullet}</Text>
                    </li>
                ))}
            </ContentList>
        </Stack>

        <Stack space="space10">
            <Heading variant="40">What is a homeowner loan?</Heading>

            <Text variant="80">
                A homeowner loan is a type of a loan that allows you to borrow
                money by using your house as a security. Homeowner loans are
                also known as secured loans because the loan is secured against
                your property.
            </Text>
        </Stack>

        <Stack space="space10">
            <Heading variant="40">How homeowner loans work</Heading>

            <Text variant="80">
                A homeowner loan allows you to borrow money against the equity
                in your home. Like any other loan, you’ll repay what you owe and
                the interest you incur over time. As the loan is secured against
                your property, your home may be at risk if you don’t keep up
                with repayments.
            </Text>
        </Stack>

        <Stack space="space20">
            <Stack space="space10">
                <Heading variant="40">
                    Is a homeowner loan right for me?
                </Heading>

                <Text variant="80">
                    Whether or not a homeowner loan will be right for you will
                    depend on your circumstances. Here are some reasons why
                    getting this type of loan might work for you.
                </Text>
            </Stack>

            <Text variant="80">
                <strong>You have a low credit score:</strong> Having a low
                credit score can make it harder to borrow. A lower credit rating
                can signal to lenders you might not keep up with repayments.
                Because a homeowner loan is secured against your property, the
                lender is taking on less risk. Homeowner loans can be a way for
                homeowners with low credit scores to borrow money.
            </Text>

            <Text variant="80">
                <strong>You need to borrow a larger amount:</strong> If you’re
                looking to borrow a large sum of money, then a homeowner loan
                might be worthwhile. As homeowner loans are less risky for
                lenders, you’re usually able to borrow more than you would with
                a personal loan. For example, if you want to borrow money to pay
                for a big expense such as home improvements, then this type of
                loan could be an option.
            </Text>

            <Text variant="80">
                <strong>You want to consolidate your debts:</strong> If you have
                multiple outstanding payments, say, for example, on your credit
                card or personal loan, then you can use a homeowner loan to
                consolidate them. This makes it easier to manage your payments
                into one monthly payment, and you’re usually offered a lower
                interest rate on a homeowner loan.
            </Text>

            <Text variant="80">
                <strong>You want more time to pay off your loan:</strong>{' '}
                Compared to other types of loans, homeowner loans tend to have
                longer repayment times. Homeowner loan lengths can be as long as
                30 years.
            </Text>
        </Stack>

        <Stack space="space20">
            <Stack space="space10">
                <Heading variant="40">
                    What can I use a homeowner loan for?
                </Heading>

                <Text variant="80">
                    You can use a homeowner loan for whatever you want. Here’s
                    what people most commonly use them for.
                </Text>
            </Stack>

            <Text variant="80">
                <strong>Reducing monthly payments:</strong> With a homeowner
                loan, you can combine credit cards, personal loans, and other
                debts into one payment with a lower interest rate. In the last
                12 months, on average, customers reduced their outgoings by over
                £800 a month with a homeowner consolidation loan. If you
                consolidate your existing borrowing, you may be extending the
                term and increasing the amount you repay in total.
            </Text>

            <Text variant="80">
                <strong>Paying for home improvements:</strong> Renovating your
                home can be expensive, and you may not have the cash immediately
                available to cover the cost. Homeowner loans can be a way to pay
                for home improvements without having to save up.
            </Text>
        </Stack>

        <Stack space="space20">
            <Stack space="space10">
                <Heading variant="40">What to know before applying?</Heading>

                <Text variant="80">
                    Here are some things to keep in mind before you apply:
                </Text>
            </Stack>

            <Text variant="80">
                <strong>Loan length and costs:</strong> Homeowner loan
                repayments tend to be spread over a longer period than unsecured
                loans. So, monthly payments can be low, but the total amount of
                interest paid can be high.
            </Text>

            <Text variant="80">
                <strong>Interest rates:</strong> Rates on homeowner loans can be
                variable or fixed. A variable rate means the rate can go up and
                down, while with a fixed rate, the rate will stay the same
                throughout a set period—for example, 5 years.
            </Text>

            <Text variant="80">
                <strong>Risk of losing home:</strong> It’s important to remember
                that with a homeowner loan, you’re putting your house up as
                security. So, if you can’t keep up with repayments, you could
                lose your home.
            </Text>
        </Stack>
    </Stack>
)

export default ContentSecured
